import { gql } from '@apollo/client';

const GET_TOURS = gql`
  query tours($where: ToursWhereInput!) {
    tours(where: $where) {
      id
      name
      tourSteps {
        id
        name
        title
        text
        media {
         src
       }
      }
    }
  }
`;

export default GET_TOURS;
